import React from 'react';

/** A page's name and one sentence on what it is for, so anyone new knows where they are. */
export default function PageTitle({ title, description }) {
  return (
    <div className="page-heading">
      <h1 className="page-title">{title}</h1>
      {description && <p className="page-desc">{description}</p>}
    </div>
  );
}
